export default defineNuxtPlugin(async (nuxtApp) => {
     return {
          provide: {
               t: nuxtApp.$i18n.t,
          }
     }
});
